// Shown in the content area INSTEAD of a screen the signed-in user's role does
// not cover (Parity #39, VAL-03). Not styled as an error: nothing broke, the
// user's permissions correctly don't include this screen. Presentational only:
// no hooks, no requests, so the screen it stands in for is never mounted.
export default function RestrictedScreen({ label }: { label: string }) {
  return (
    <div data-testid="restricted-screen" style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
      padding: '60px 20px', maxWidth: 380, margin: '0 auto',
    }}>
      <div aria-hidden="true" style={{
        width: 44, height: 44, borderRadius: '50%', background: 'var(--color-gray-100)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14,
      }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-gray-600)"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="10" width="16" height="10" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
      </div>
      <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--color-black)', marginBottom: 5 }}>
        Not part of your access
      </div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--color-gray-600)', lineHeight: 1.55 }}>
        Your permissions don't include {label}. Ask an Owner if you need it.
      </div>
    </div>
  )
}
